import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
var routes = [{
  path: '/address/list',
  name: ROUTE_NAME.ADDRESS_LIST,
  meta: {
    title: '地址管理'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "address" */
    '@/pages/address/list.vue');
  }
}, {
  path: '/address/edit/:addressId?',
  name: ROUTE_NAME.ADDRESS_EDIT,
  meta: {
    title: '地址管理'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "address" */
    '@/pages/address/edit.vue');
  }
}];
export default routes;